<template>
    <div class="container-fluid">
        <Breadcrumb title="Add SMTP Server" v-bind:button-show="false" v-show="!id"></Breadcrumb>
        <Breadcrumb v-bind:title="'Edit SMTP Server #' + id" v-bind:button-show="false" v-show="id"></Breadcrumb>

        <div class="row" style="position: relative">
            <div class="col-12 row-preloader" v-if="id">
                <Preloader v-bind:class="{preloader: loading}" v-show="loading"></Preloader>
            </div>
            <div class="col-12" v-show="!loading">
                <div class="card">
                    <div class="card-body">
                        <SmtpServerForm :id="id" @hidePreloader="hidePreloader"></SmtpServerForm>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Preloader from '../components/Preloader';
    import SmtpServerForm from './forms/SmtpServerForm';
    import Breadcrumb from '../components/Breadcrumb';

    export default {
        name: 'SmtpServer',
        props: ['id'],
        components: {
            Preloader, SmtpServerForm, Breadcrumb
        },
        data() {
            return {
                loading: false,
                waiting: null,
                readinnes: [],
                configsDates: []
            }
        },
        mounted() {
            if (this.id) {
                this.loading = true;
            }
        },
        methods: {
            hidePreloader(value) {
                this.loading = value
            }
        }
    }
</script>

<style scoped>

</style>
